import { SecondaryButton } from '@get-e/react-components';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { Typography, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { GridRowParams } from '@mui/x-data-grid-pro';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { COLORS } from '../../../../constants/colors';
import { BUTTON_WIDTH } from '../../../../constants/layout';

const useStyles = makeStyles({
    mobileContent: {
        color: COLORS.BLACK,
        marginLeft: '.5rem',
    },
    editButton: {
        width: BUTTON_WIDTH,
        marginRight: '1rem',
        marginLeft: '0.2rem',
        color: COLORS.BLUE,
        border: `2px solid ${COLORS.BLUE}`,
    },
    deleteButton: {
        width: BUTTON_WIDTH,
        color: COLORS.RED,
        border: `2px solid ${COLORS.RED}`,
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '1rem .5rem 1rem .5rem',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
    },
});

export const useUsersColumnsMobile = (handleDelete: () => void, handleEdit: () => void) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return useMemo(() => ({ row }: GridRowParams) => (
        <Box className={classes.container}>
            <Box display="flex" alignItems="center" margin="0 0.5rem 0.75rem 0" color={COLORS.SLATE_GREY}>
                <PersonOutlineOutlinedIcon />
                <Typography className={classes.mobileContent}>{row.name}</Typography>
            </Box>
            <Box display="flex" alignItems="center" margin="0 0.5rem 0.75rem 0" color={COLORS.SLATE_GREY}>
                <EmailOutlinedIcon />
                <Typography className={classes.mobileContent}>{row.email}</Typography>
            </Box>
            <Typography>
                <strong>{t('pages.users.fields.lastSeen')}: </strong> {row.lastSeen}
            </Typography>
            <Typography>
                <strong> {t('pages.users.fields.permissions')}: </strong>
                {row.permissions.manageUsers && t('pages.users.fields.users')} &nbsp;
                {row.permissions.manageRidesBookedByOthers && t('pages.users.fields.rides')}
            </Typography>
            <Box display="flex" justifyContent="flex-start" margin="2rem 0 0 0" color={COLORS.SLATE_GREY}>
                <SecondaryButton className={classes.editButton} onClick={handleEdit}>
                    {t('buttonName.edit')}
                </SecondaryButton>
                <SecondaryButton className={classes.deleteButton} variation="danger" onClick={handleDelete}>
                    {t('buttonName.delete')}
                </SecondaryButton>
            </Box>
        </Box>
    ), [classes.container, classes.deleteButton, classes.editButton, classes.mobileContent, handleDelete, handleEdit, t]);
};
